import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { showToast } from "../Toast";
import { toast } from "react-toastify";
const sendCode = async (phoneNumber, setLoading, history, setPhone) => {
  setLoading(true);
  const body = { mobile_number: phoneNumber };
  ApiCall(
    "post",
    urls.verfiyCode,
    body,
    "sendVerifySms",
    null,
    function (e) {
      // toast.success(e.data, {
      //   position: "top-center",
      //   autoClose: 5000
      // });
      setPhone(phoneNumber);
      history.push("/verify");
      setLoading(false);
    },
    () => {
      setLoading(false);
    }
  );
};
export const validatePhone = (phone) => {
  var PHONE = /^([0]{0,1})([9]{1})([0-9]{9})$/;
  return PHONE.test(phone);
};

export const onClickSendCode = (
  phoneNumber,
  setLoading,
  history,
  setPhone,
  checked
) => {
  if (checked) {
    if (phoneNumber !== "") {
      if (validatePhone(phoneNumber)) {
        sendCode(phoneNumber, setLoading, history, setPhone);
      } else {
        showToast("شماره تلفن همراه وارد شده معتبر نمی باشد");
      }
    } else {
      toast.warn("لطفا شماره تلفن همراه را وارد نمایید");
    }
  } else toast.warn("برای ورود ابتدا قوانین و مقررات را بپذیرید");
};
export const Button = ({ phoneNumber, setPhone, checked }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  return (
    <div
      className="BlueButtonAbsolute"
      id="Billhistory"
      style={{ animationDelay: "0.3s" }}
      onClick={() =>
        onClickSendCode(phoneNumber, setLoading, history, setPhone, checked)
      }
    >
      {loading ? (
        <BeatLoader
          size={5}
          //size={"150px"} this also works
          color={"white"}
          loading={true}
        />
      ) : (
        <span>ورود / ثبت نام</span>
      )}
    </div>
  );
};
